import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import {Container,Grid} from '@material-ui/core';
import {NavLink, useParams} from 'react-router-dom';
import { useEffect } from 'react';
import {  routeFormatter } from '../../utils/common.utils';
import Preloader from '../../components/PreLoader';
import Page from '../../models/page.model';
import { fetchPageBySlug } from '../../services/page.service';
import { lang } from '../../config/app.config';
import {FaCaretRight} from 'react-icons/fa';
interface params{
  slug:string
}



const Pages:React.FC = ()=>{

  const {slug} =  useParams<params>();

  const [page,setPage] = React.useState<Page|undefined>(undefined);
  const [loading,setLoading] = React.useState<boolean>(false);

  const fetchPage = async() => {
    setLoading(true);
    const notice = await fetchPageBySlug(slug) || undefined;
    setPage(notice);
    setLoading(false)
  }

  useEffect(()=>{
    fetchPage();
  },[slug]) //eslint-disable-line






  return(
    <>
    {
    !loading?
    page?
    <>
     <Breadcrumb routes={[{title:page.title|| ''}]} slug={'/page/'+page.slug}/>
     
      <div className="section-padding-2 " style={{background:'white'}}>
        <Container maxWidth="lg">
          <Grid container className="justify-content-center" spacing={2}>
            {
              page.sidebar && page.sidebar.length>1?
              <Grid item xs={12} lg={3}>
                <div className="">
                  <ul className="ecn-sidebar">
                    {
                      page.sidebar.map(item=>(
                        <li key={item.id}>
                          <NavLink to={'/'+lang+routeFormatter(item.key)} activeClassName="active">
                            <span><FaCaretRight/></span>
                          {item.name}</NavLink>
                        </li>
                      ))
                    }
                  </ul>
                </div>
              </Grid>:""
            }
              <Grid item xs={12} lg={page.sidebar && page.sidebar.length >1 ?9:12}>
                {
                  page.thumbnail?<img src={page.thumbnail || ''} alt="" className="img-fluid mb-1"/>:''
                }
                <div className="blog-details" dangerouslySetInnerHTML={{ __html: page.body|| '' }}>
                </div>
              </Grid>
           
          </Grid>
        </Container>
      </div>
      </>:
      <h3 className="text-center section-break-4 text-28-primary">
        Sorry page not found!!
      </h3> // no news
      :<Preloader/>} 
      {/* <SimlarBlogs/> */}
    </>
  );
}

export default Pages;